import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import {getReportData} from '../reports_selectors';
import ReportSummary from './ReportSummary';
import {ReportConfig} from 'src/js/model/reports_config';

class ReportSummaryContainer extends React.Component {
  render() {
    const {reportConfig, reportData} = this.props;
    return (
      <ReportSummary reportConfig={reportConfig} reportData={reportData} />
    );
  }
}

ReportSummaryContainer.displayName = 'ReportSummaryContainer';

/* eslint-disable react/no-unused-prop-types */
ReportSummaryContainer.propTypes = {
  detailId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reportsResult: PropTypes.objectOf(PropTypes.any),
  reportConfig: PropTypes.instanceOf(ReportConfig).isRequired,
  reportId: PropTypes.string,
  reportsStateId: PropTypes.string.isRequired,
};

ReportSummaryContainer.defaultProps = {
  detailId: undefined,
  reportId: undefined,
  reportsResult: undefined,
};

export default connect((state, props) => ({
  reportData: getReportData(state, props),
}))(ReportSummaryContainer);
